/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
     <br><br>
  <div>
  <div class="formPosition">
    <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
            <v-card style="margin:auto;" width="900px">

              <template >

                  <v-toolbar color="grey lighten-2">

               <v-row>
                    <v-col sm="4" cols="12" md="4">

<v-btn v-if="novo"  color="primary" size="10" fab   @click="novo= false"><v-icon large   >clear</v-icon></v-btn>
<v-btn v-if="!novo"  color="primary" size="10" fab   @click="editar()"><v-icon large   >edit</v-icon></v-btn>

    </v-col>

     <v-col sm="4" cols="12" md="6">  <!--  form titlte section   {{ formTitle }}-->
  <span> Cadastro de Preços de Serviços</span>

     </v-col>

      <v-col sm="4"  cols="12" md="2">
        <v-btn size="18"    fab dark color="success"  @click="novo=true">
              <v-icon dark>add</v-icon>
            </v-btn>
    </v-col>

  </v-row>

                  </v-toolbar>

              </template>

 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

              <v-card-text>

                <v-container  >

<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                  <v-row>
                    <v-col  cols="12" md="12">
                      <v-combobox
                        v-model="servicoSelected"
                        :rules="ruleRequired"
                        item-value="pk_outros_servicos"
                        item-text="nome"
                        :items="servicos"

                        chips
                        label="Selecione o serviço"
                      ></v-combobox>
                    </v-col>
                    <v-col  cols="12" md="12">
                      <v-text-field
                        :rules="ruleNumber"
                        v-model="preco"
                        label="Insira o Valor"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                   <v-row>
                    <v-col md="4"></v-col>
                    <v-col md="4"></v-col>
                    <v-col md="2"><!--<v-btn fab   color="success"      @click="close"><v-icon large >edit</v-icon></v-btn>-->
                    </v-col>
                    <v-col md="2">
                        <v-btn    :disabled="!valid && novo"  fab        color="success"    @click="save"><v-icon large   >send</v-icon></v-btn>

                    </v-col>
                </v-row>
                </v-container>
              </v-card-text>

</v-form>

            </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],

    progresso: false,
    novo: false,
    valid: true,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    cursos: [],

    isLoading: false,
    servico: '',
    cor: '',

    searchInDb: '',
    servicoSelected: null,
    preco: 0,
    servicos: [],
    servicosTabela: [],
    valorFormatado: '',
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'Invalido.'
      }
    ],
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    headers: [
      {
        text: 'Nome do Serviço',
        align: 'left',
        sortable: false,
        value: 'servico'
      },

      { text: 'Preço', value: 'preco' },
      { text: 'Autor', value: 'autor' },
      { text: 'data cadastro', value: 'data_' }
    ],
    msg: '',
    editedIndex: -1

  }),

  computed: {

    loggedUserName () {
      return ls.get('nomeUsuario')
    },

    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initializeServicos()
  },

  methods: {
    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL

    async initializeServicos () {
      try {
        //   let  payload =""

        this.isLoading = true
        this.servicos = await axios
          .get('/ServicosFindAll')
          .then(res => res.data)
        console.log(this.servicos)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    chamaDialogo () {
      this.dialog = true
    },

    close () {
      this.dialog = false
      this.$refs.form.reset()
    },
    ObterValorFormatado (valor) {
      let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
      this.valorFormatado = formated.toString().replace('AOA', '')
    },
    async save () {
      if (this.$refs.form.validate()) {
        this.progresso = true
        this.ObterValorFormatado(this.preco)

        let params =
        {
          pk_outros_servicos_preco: 0,
          servico: this.servicoSelected.pk_outros_servicos,
          preco: this.valorFormatado.toString().trim()
        }

        let paramsTabela =
       {
         servico: this.servicoSelected.nome,
         preco: this.valorFormatado,
         autor: ls.get('nomeUsuario'),
         data_: new Date()
       }

        try {
          let corMensagem = 'msgError'
          let msg = await axios
            .post('/precoServicoInsertOrUpdate', params)
            .then(res => res.data)
          this.progresso = false

          if (msg.length) {
            corMensagem = 'msgError'
            this.text = 'Ocorreu um erro ao tentar efectuar a operação'
          } else {
            corMensagem = 'msgSucess'
            this.text = 'Operação efectuada com sucesso'
            this.servicosTabela.unshift(paramsTabela)
            this.close()
          }
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': corMensagem, 'timeout': 5000 })
        } catch (error) {
          this.progresso = false
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    }

  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
